import { Button, Grid, Typography, styled, useTheme } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { observer } from "mobx-react";
import React from "react";
import { ReportAccessType } from "../../../../../../models/Reporting/ReportAccessControls";
import { useStore } from "../../../../../../utils/useStore";
import { ReportEditorStore } from "../../../Stores/ReportEditorStore";

const MainSectionTitleText = styled(Typography)(({ theme }) => ({
    fontFamily: "Inter",
    fontSize: "20px",
    letterSpacing: "0",
    fontWeight: "bold",
    lineHeight: "28px",
}));

const ReportPermissionSection: React.FC = observer(() => {
    const store = useStore(ReportEditorStore);

    function getReportAccess(accessType: ReportAccessType) {
        return store.displayUsers(accessType, "");
    }

    const theme = useTheme();
    return (
        <>
            <Grid item xs={12} sx={{ paddingBottom: "17px" }}>
                <MainSectionTitleText>Permissions</MainSectionTitleText>
                <Typography variant="caption">
                    By default, anyone in your org will be able to view and edit
                    reports unless you specify otherwise.
                </Typography>
            </Grid>

            <Grid item xs={12} sx={{ marginTop: 3 }}>
                <MainSectionTitleText sx={{ fontSize: "16px" }}>
                    Access Control Lists
                </MainSectionTitleText>

                <Grid container spacing={2}>
                    <Grid item>
                        <Button
                            disabled={!store.currentReport}
                            sx={{ textTransform: "none", fontWeight: "bold" }}
                            onClick={() =>
                                store.onOpenAccessControls(
                                    ReportAccessType.View,
                                )
                            }
                            size="medium"
                            startIcon={<VisibilityIcon />}
                            variant={"outlined"}
                            color="secondary"
                        >
                            Choose Viewers...
                        </Button>
                    </Grid>
                    <Grid item>
                        {store.currentReport &&
                            ((store.currentReport?.anyViewACLs ? (
                                getReportAccess(ReportAccessType.View)
                            ) : (
                                <Typography
                                    sx={{
                                        fontWeight: "bold",
                                        color: theme.palette.text.secondary,
                                        paddingTop: "9px",
                                    }}
                                >
                                    {" "}
                                    -
                                    {
                                        "The entire organization will be able to view this report"
                                    }
                                </Typography>
                            )) as React.ReactNode)}
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item>
                        <Button
                            disabled={!store.currentReport}
                            sx={{ textTransform: "none", fontWeight: "bold" }}
                            startIcon={<EditIcon />}
                            onClick={() =>
                                store.onOpenAccessControls(
                                    ReportAccessType.Edit,
                                )
                            }
                            size="medium"
                            variant={"outlined"}
                            color="secondary"
                        >
                            Choose Editors....
                        </Button>
                    </Grid>
                    <Grid item>
                        {store.currentReport &&
                            ((store.currentReport?.anyEditACLs ? (
                                getReportAccess(ReportAccessType.Edit)
                            ) : (
                                <Typography
                                    sx={{
                                        fontWeight: "bold",
                                        color: theme.palette.text.secondary,
                                        paddingTop: "9px",
                                    }}
                                >
                                    {" "}
                                    -
                                    {
                                        "The entire organization will be able to edit this report"
                                    }
                                </Typography>
                            )) as React.ReactNode)}
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
});

export default ReportPermissionSection;
